import { render, staticRenderFns } from "./pro-item.vue?vue&type=template&id=0c8a9355&scoped=true&"
import script from "./pro-item.vue?vue&type=script&lang=js&"
export * from "./pro-item.vue?vue&type=script&lang=js&"
import style0 from "./pro-item.vue?vue&type=style&index=0&id=0c8a9355&scoped=true&lang=scss&"
import style1 from "./pro-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a9355",
  null
  
)

export default component.exports